var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.21289 20.1666V3.66659C6.21289 3.18036 6.40604 2.71404 6.74986 2.37022C7.09368 2.02641 7.55999 1.83325 8.04622 1.83325H15.3796C15.8658 1.83325 16.3321 2.02641 16.6759 2.37022C17.0197 2.71404 17.2129 3.18036 17.2129 3.66659V20.1666H6.21289Z",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21281 11H4.37948C3.89325 11 3.42693 11.1932 3.08311 11.537C2.7393 11.8808 2.54614 12.3471 2.54614 12.8333V18.3333C2.54614 18.8196 2.7393 19.2859 3.08311 19.6297C3.42693 19.9735 3.89325 20.1667 4.37948 20.1667H6.21281",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2129 8.25H19.0462C19.5325 8.25 19.9988 8.44315 20.3426 8.78697C20.6864 9.13079 20.8796 9.5971 20.8796 10.0833V18.3333C20.8796 18.8196 20.6864 19.2859 20.3426 19.6297C19.9988 19.9735 19.5325 20.1667 19.0462 20.1667H17.2129",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87964 5.5H13.5463",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87964 9.16675H13.5463",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87964 12.8333H13.5463",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87964 16.5H13.5463",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrg);
export default __webpack_public_path__ + "static/media/org.c259bb132899626b639646248ed16870.svg";
export { ForwardRef as ReactComponent };